const MEHDI_QUICK_PRODUCT_CACHE_LIMIT = 12;
const MEHDI_QUICK_COLLECTION_CACHE_LIMIT = 4;
const MEHDI_QUICK_PREFETCH_DELAY = 180;

const mehdiQuickProductCache = new Map();
const mehdiQuickProductRequests = new Map();
const mehdiQuickCollectionCache = new Map();
const mehdiQuickCollectionRequests = new Map();

let mehdiQuickActiveController = null;
let mehdiQuickRenderToken = 0;
let mehdiQuickPrefetchTimer = null;

if (typeof document !== 'undefined' && document.addEventListener) {
  document.addEventListener('click', function (e) {
    if (window.innerWidth <= 749) return;

    const target = getEventElement(e);
    if (!target) return;

    if (target.closest('#mehdiPanel.active #mehdiContent slideshow-controls, #mehdiPanel.active #mehdiContent slideshow-arrows')) {
      pauseMehdiQuickVideos();
    }

    if (target.id === 'mehdiOverlay') {
      closeMehdiQuick();
      return;
    }

    const link = target.closest('a[href*="/products/"]');
    if (!link) return;

    if (!link.closest('.card-product, .product-card, .grid__item, product-card')) return;

    if (!canOpenMehdiQuick()) return;

    e.preventDefault();
    e.stopPropagation();

    const productUrl = link.href;
    const currentCollection = getCurrentCollectionContext();

    fetchAndRenderProduct(productUrl, currentCollection);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMehdiQuick();
    }
  });

  document.addEventListener('slideshow:select', handleMehdiQuickMediaChange);

  document.addEventListener('pointerover', function (e) {
    if (window.innerWidth <= 749) return;

    const target = getEventElement(e);
    if (!target) return;

    const link = getQuickProductLink(target);
    if (!link || !canOpenMehdiQuick()) return;
    if (e.relatedTarget instanceof Node && link.contains(e.relatedTarget)) return;

    clearTimeout(mehdiQuickPrefetchTimer);

    mehdiQuickPrefetchTimer = window.setTimeout(function () {
      prefetchMehdiQuickProduct(link.href);
    }, MEHDI_QUICK_PREFETCH_DELAY);
  }, true);

  document.addEventListener('pointerout', function (e) {
    const target = getEventElement(e);
    if (!target) return;

    const link = getQuickProductLink(target);
    if (!link) return;
    if (e.relatedTarget instanceof Node && link.contains(e.relatedTarget)) return;

    clearTimeout(mehdiQuickPrefetchTimer);
  }, true);

  document.addEventListener('focusin', function (e) {
    if (window.innerWidth <= 749) return;

    const target = getEventElement(e);
    if (!target) return;

    const link = getQuickProductLink(target);
    if (!link || !canOpenMehdiQuick()) return;

    prefetchMehdiQuickProduct(link.href);
  });
}

function fetchAndRenderProduct(productUrl, currentCollection = null) {
  const mehdiContent = document.getElementById('mehdiContent');
  const mehdiPanel = document.getElementById('mehdiPanel');
  const mehdiOverlay = document.getElementById('mehdiOverlay');
  const currentProductHandle = getProductHandleFromUrl(productUrl);
  const productFetchUrl = getFetchUrl(productUrl);
  const renderToken = ++mehdiQuickRenderToken;

  if (!mehdiContent || !mehdiPanel || !mehdiOverlay) {
    console.log('Quick view container bulunamadı');
    return false;
  }

  pauseMehdiQuickVideos();

  mehdiPanel.classList.add('active');
  mehdiOverlay.classList.add('active');

  mehdiContent.innerHTML = getMehdiLoaderHtml();

  if (mehdiQuickActiveController) {
    mehdiQuickActiveController.abort();
  }

  mehdiQuickActiveController = typeof AbortController !== 'undefined'
    ? new AbortController()
    : null;

  fetchMehdiQuickProductHtml(
    productFetchUrl,
    mehdiQuickActiveController ? mehdiQuickActiveController.signal : null
  )
    .then(function (html) {
      if (renderToken !== mehdiQuickRenderToken) return;

      const temp = document.createElement('div');
      temp.innerHTML = html;

      const mainContent = temp.querySelector('#MainContent');

      if (!mainContent) {
        mehdiContent.innerHTML = `
          <div style="padding:40px;">
            Ürün içeriği bulunamadı.
          </div>
        `;
        return;
      }

      mehdiContent.innerHTML = mainContent.innerHTML;

      removeExistingRecommendations(mehdiContent);
      optimizeMehdiQuickImages(mehdiContent);

      if (currentCollection && currentCollection.handle) {
        scheduleMehdiQuickIdleTask(function () {
          if (renderToken !== mehdiQuickRenderToken) return;

          loadCollectionRecommendations({
            collectionHandle: currentCollection.handle,
            collectionUrl: currentCollection.url,
            currentProductHandle: currentProductHandle,
            mountEl: mehdiContent,
            renderToken: renderToken
          });
        });
      }

      runMiniSetScripts(mehdiContent);
      bindInnerQuickLinks();
    })
    .catch(function (err) {
      if (err && err.name === 'AbortError') return;
      if (renderToken !== mehdiQuickRenderToken) return;

      console.log('Quick view yüklenemedi:', err);

      mehdiContent.innerHTML = `
        <div style="padding:40px;">
          Ürün yüklenemedi.
        </div>
      `;
    });

  return true;
}

function getQuickProductLink(target) {
  const link = target.closest('a[href*="/products/"]');
  if (!link) return null;

  if (!link.closest('.card-product, .product-card, .grid__item, product-card')) {
    return null;
  }

  return link;
}

function prefetchMehdiQuickProduct(productUrl) {
  const productFetchUrl = getFetchUrl(productUrl);

  if (
    !productFetchUrl ||
    mehdiQuickProductCache.has(productFetchUrl) ||
    mehdiQuickProductRequests.has(productFetchUrl)
  ) {
    return;
  }

  fetchMehdiQuickProductHtml(productFetchUrl, null).catch(function () {
    // Ön yükleme başarısız olursa tıklama anında normal istek yeniden denenir.
  });
}

function fetchMehdiQuickProductHtml(productFetchUrl, signal) {
  if (mehdiQuickProductCache.has(productFetchUrl)) {
    const cachedHtml = mehdiQuickProductCache.get(productFetchUrl);

    touchMehdiQuickCache(
      mehdiQuickProductCache,
      productFetchUrl,
      cachedHtml,
      MEHDI_QUICK_PRODUCT_CACHE_LIMIT
    );

    return Promise.resolve(cachedHtml);
  }

  if (mehdiQuickProductRequests.has(productFetchUrl)) {
    return mehdiQuickProductRequests.get(productFetchUrl);
  }

  const fetchOptions = {
    credentials: 'same-origin',
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  };

  if (signal) {
    fetchOptions.signal = signal;
  }

  const request = fetch(productFetchUrl, fetchOptions)
    .then(function (res) {
      if (!res.ok) {
        throw new Error('Ürün isteği başarısız: ' + res.status);
      }

      return res.text();
    })
    .then(function (html) {
      touchMehdiQuickCache(
        mehdiQuickProductCache,
        productFetchUrl,
        html,
        MEHDI_QUICK_PRODUCT_CACHE_LIMIT
      );

      return html;
    })
    .finally(function () {
      mehdiQuickProductRequests.delete(productFetchUrl);
    });

  mehdiQuickProductRequests.set(productFetchUrl, request);

  return request;
}

function touchMehdiQuickCache(cache, key, value, limit) {
  if (cache.has(key)) {
    cache.delete(key);
  }

  cache.set(key, value);

  while (cache.size > limit) {
    const oldestKey = cache.keys().next().value;
    cache.delete(oldestKey);
  }
}

function optimizeMehdiQuickImages(root) {
  if (!root) return;

  const images = root.querySelectorAll('img');

  images.forEach(function (image, index) {
    image.decoding = 'async';

    if (index === 0) {
      image.loading = 'eager';
      image.fetchPriority = 'high';
      return;
    }

    image.loading = 'lazy';
    image.fetchPriority = 'low';
  });
}

function scheduleMehdiQuickIdleTask(callback) {
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(callback, { timeout: 1200 });
    return;
  }

  window.setTimeout(callback, 450);
}

function getMehdiLoaderHtml() {
  return `
    <div style="
      width:100%;
      min-height:100vh;
      display:flex;
      flex-direction:column;
      align-items:center;
      justify-content:center;
      background:#fff;
      gap:18px;
    ">
      <svg width="58" height="58" viewBox="0 0 58 58" xmlns="http://www.w3.org/2000/svg">
        <g>
          <circle
            cx="29"
            cy="29"
            r="23"
            stroke="rgba(21,70,52,0.16)"
            stroke-width="5"
            fill="none"
          ></circle>

          <circle
            cx="29"
            cy="29"
            r="23"
            stroke="#154634"
            stroke-width="5"
            fill="none"
            stroke-linecap="round"
            stroke-dasharray="36 120"
          ></circle>

          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 29 29"
            to="360 29 29"
            dur="0.8s"
            repeatCount="indefinite"
          />
        </g>
      </svg>

      <div style="
        font-size:14px;
        color:#154634;
        letter-spacing:.3px;
        font-family:inherit;
      ">
        Ürün yükleniyor...
      </div>
    </div>
  `;
}

function runMiniSetScripts(root) {
  if (!root) return;

  root.querySelectorAll('script').forEach(function (script) {
    if (!script.textContent || !script.textContent.includes('data-mini-set-form')) return;

    const executableScript = document.createElement('script');
    executableScript.textContent = script.textContent;
    if (!document.body) return;

    document.body.appendChild(executableScript);
    executableScript.remove();
  });
}

function closeMehdiQuick() {
  const mehdiPanel = document.getElementById('mehdiPanel');
  const mehdiOverlay = document.getElementById('mehdiOverlay');

  pauseMehdiQuickVideos();
  clearTimeout(mehdiQuickPrefetchTimer);
  mehdiQuickRenderToken += 1;

  if (mehdiQuickActiveController) {
    mehdiQuickActiveController.abort();
    mehdiQuickActiveController = null;
  }

  if (mehdiPanel) {
    mehdiPanel.classList.remove('active');
  }

  if (mehdiOverlay) {
    mehdiOverlay.classList.remove('active');
  }
}

function handleMehdiQuickMediaChange(event) {
  const target = getEventElement(event);

  if (target && target.closest('#mehdiPanel #mehdiContent')) {
    pauseMehdiQuickVideos();
  }
}

function pauseMehdiQuickVideos() {
  const quickViewRoot = document.getElementById('mehdiContent');
  if (!quickViewRoot) return;

  quickViewRoot.querySelectorAll('video').forEach(function (video) {
    video.pause();
  });

  quickViewRoot.querySelectorAll('iframe[data-video-type]').forEach(function (iframe) {
    if (!iframe.contentWindow) return;

    iframe.contentWindow.postMessage(
      iframe.dataset.videoType === 'youtube'
        ? '{"event":"command","func":"pauseVideo","args":""}'
        : '{"method":"pause"}',
      '*'
    );
  });
}

function getEventElement(event) {
  if (!event || !event.target) return null;

  if (event.target instanceof Element) return event.target;

  return event.target.parentElement || null;
}

function canOpenMehdiQuick() {
  return Boolean(
    document.getElementById('mehdiContent') &&
    document.getElementById('mehdiPanel') &&
    document.getElementById('mehdiOverlay')
  );
}

function getCurrentCollectionContext() {
  try {
    const parsed = new URL(window.location.href);
    const match = parsed.pathname.match(/^(.*\/collections\/([^\/]+))(?:\/|$)/);

    if (!match) return null;

    return {
      handle: decodeURIComponent(match[2]),
      url: match[1]
    };
  } catch (e) {
    return null;
  }
}

function getFetchUrl(url) {
  try {
    return new URL(url, window.location.origin).href;
  } catch (e) {
    return url;
  }
}

function getProductHandleFromUrl(url) {
  try {
    const parsed = new URL(url, window.location.origin);
    const match = parsed.pathname.match(/\/products\/([^\/]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  } catch (e) {
    return null;
  }
}

function removeExistingRecommendations(root) {
  if (!root) return;

  const selectors = [
    '[id*="__product_recommendations"]',
    '#shopify-section-product-recommendations',
    '[data-testid="product-recommendations-section"]',
    '.mehdi-related'
  ];

  selectors.forEach(function (selector) {
    root.querySelectorAll(selector).forEach(function (el) {
      const shopifySection = el.closest('.shopify-section');

      if (shopifySection) {
        shopifySection.remove();
      } else {
        el.remove();
      }
    });
  });
}

function loadCollectionRecommendations({
  collectionHandle,
  collectionUrl,
  currentProductHandle,
  mountEl,
  renderToken
}) {
  const recommendationsUrl = collectionUrl || getLocalizedCollectionUrl(collectionHandle);

  if (!recommendationsUrl || !mountEl) return;

  fetchMehdiQuickCollectionCards(recommendationsUrl)
    .then(function (productCards) {
      if (renderToken !== mehdiQuickRenderToken) return;
      if (!mountEl.isConnected) return;

      const cards = productCards
        .filter(function (card) {
          return card.handle !== currentProductHandle;
        })
        .slice(0, 4);

      if (!cards.length) return;

      const relatedHTML = `
        <section class="mehdi-related">
          <h3 class="mehdi-related__title">
            Benzer Ürünler
          </h3>

          <div class="mehdi-related__grid mehdi-related__grid--theme-cards">
            ${cards.map(function (card) {
              return card.html;
            }).join('')}
          </div>
        </section>
      `;

      mountEl.insertAdjacentHTML('beforeend', relatedHTML);

      optimizeMehdiQuickImages(mountEl.querySelector('.mehdi-related'));
      bindInnerQuickLinks();
    })
    .catch(function (err) {
      console.log('Benzer ürünler yüklenemedi:', err);
    });
}

function fetchMehdiQuickCollectionCards(recommendationsUrl) {
  if (mehdiQuickCollectionCache.has(recommendationsUrl)) {
    const cachedCards = mehdiQuickCollectionCache.get(recommendationsUrl);

    touchMehdiQuickCache(
      mehdiQuickCollectionCache,
      recommendationsUrl,
      cachedCards,
      MEHDI_QUICK_COLLECTION_CACHE_LIMIT
    );

    return Promise.resolve(cachedCards);
  }

  if (mehdiQuickCollectionRequests.has(recommendationsUrl)) {
    return mehdiQuickCollectionRequests.get(recommendationsUrl);
  }

  const request = fetch(recommendationsUrl, {
    credentials: 'same-origin',
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
    .then(function (res) {
      if (!res.ok) {
        throw new Error('Koleksiyon isteği başarısız: ' + res.status);
      }

      return res.text();
    })
    .then(function (html) {
      const temp = document.createElement('div');
      temp.innerHTML = html;

      const productCards = temp.querySelectorAll(
        '.card-product, .product-card, .grid__item, product-card'
      );

      const cards = [];

      productCards.forEach(function (card) {
        if (cards.length >= 16) return;

        const link = card.querySelector('a[href*="/products/"]');
        if (!link) return;

        const handle = getProductHandleFromUrl(link.href);
        if (!handle) return;

        cards.push({
          handle: handle,
          html: card.outerHTML
        });
      });

      touchMehdiQuickCache(
        mehdiQuickCollectionCache,
        recommendationsUrl,
        cards,
        MEHDI_QUICK_COLLECTION_CACHE_LIMIT
      );

      return cards;
    })
    .finally(function () {
      mehdiQuickCollectionRequests.delete(recommendationsUrl);
    });

  mehdiQuickCollectionRequests.set(recommendationsUrl, request);

  return request;
}

function bindInnerQuickLinks() {
  const root = document.getElementById('mehdiContent');
  if (!root) return;

  root.querySelectorAll('.mehdi-related a[href*="/products/"]')
    .forEach(function (el) {
      if (!el || !el.addEventListener) return;

      el.addEventListener('click', function (e) {
        if (window.innerWidth <= 749) return;
        if (!canOpenMehdiQuick()) return;

        e.preventDefault();
        e.stopPropagation();

        const currentCollection = getCurrentCollectionContext();

        fetchAndRenderProduct(this.href, currentCollection);
      });
    });
}

function getLocalizedCollectionUrl(collectionHandle) {
  if (!collectionHandle) return null;

  try {
    const parsed = new URL(window.location.href);
    const collectionsIndex = parsed.pathname.indexOf('/collections/');
    const localePrefix = collectionsIndex > -1 ? parsed.pathname.slice(0, collectionsIndex) : '';

    return localePrefix + '/collections/' + encodeURIComponent(collectionHandle);
  } catch (e) {
    return '/collections/' + encodeURIComponent(collectionHandle);
  }
}
